import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { GetReservations, GetReservationTotals } from '../../../api/services/pms';
import moment from 'moment';
import GridPanel from '../../../components/GridPanel'
import _ from 'lodash'
import { Currencies } from '../../../components/shared/currencies'
import { endpoint } from '../../../api/http'
import { useTextResources } from '../../../language';
import { onWarning,onError } from '../../../components/shared/messages'
import { GetHotels } from '../../../api/services/organization';
import { Loader, Dimmer} from 'semantic-ui-react';
import { dateFormat } from '../../../components/shared/constants';


export const lastReservationsWidget = ({ HotelIds }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const text = useTextResources()
    const dateFormatter = ({ value }) => {
        return value && moment(value).format(dateFormat)
    }
    const amountFormatter = ({ value }) => {
        const currencySymbol = window.user?.CurrentHotel?.MainCurrencyId?Currencies[window.user.CurrentHotel.MainCurrencyId].symbol:""
        return `${value ? value.toFixed(2) : 0.00} ${currencySymbol ? currencySymbol : ""}`
    }
    const reservationFormatter = ({ value, row }) => {
        if (row) {
            return <a target="_blank" rel="noopener noreferrer" href={`${endpoint}PMS/Reservations/Index/${row.ReservationId}?hotelid=${row.HotelId}`}>{value}</a>
        } else {
            return value
        }
    }
    const actionColor = ({ value }) => {
        if (value === "Canceled Reservations") {
            return <span style={{ color: "red" }}>{value}</span>
        } else {
            return <span style={{ color: "green" }}>{value}</span>
        }
    }
    const gridOptions = {
        columns: [
            {
                displayField: 'action',
                name: 'action',
                title: text("Action"),
                formatter: actionColor

            },
            {
                displayField: 'HotelName',
                name: 'HotelName',
                title: text("Hotel")
            },
            {
                displayField: 'Number',
                name: 'Number',
                title: text("Reservation"),
                formatter: reservationFormatter
            },
            {
                displayField: 'CheckInDate',
                name: 'CheckInDate',
                title: text("mobile_check_in"),
                formatter: dateFormatter
            },
            {
                displayField: 'CheckOutDate',
                name: 'CheckOutDate',
                title: text("mobile_check_out"),
                formatter: dateFormatter
            },
            {
                displayField: 'TotalAmountDebitAfterTax',
                name: 'TotalAmountDebitAfterTax',
                title: text("TotalPrice"),
                formatter: amountFormatter
            },
        ],
        summary: true,
        cacheId: 'LastReservationWidget',
        customOptions: {
            group: {
                grouping: [{ columnName: 'action' }],
                extensions: [{ columnName: 'TotalAmountDebitAfterTax', groupingEnabled: false }]
            }
        },
        totalSummaryItems: [
            { columnName: 'TotalAmountDebitAfterTax', type: 'sum', amountFormatter },
        ],
        groupSummaryItems: [
            { columnName: 'TotalAmountDebitAfterTax', type: 'sum', showInGroupFooter: false, alignByColumn: true },
        ],
        columnExtensions: [
            { columnName: 'action', width: 150 },
            { columnName: 'HotelName', width: 100 },
            { columnName: 'Number', width: 130 },
            { columnName: 'CheckInDate', width: 110 },
            { columnName: 'CheckOutDate', width: 110 },
            { columnName: 'TotalAmountDebitAfterTax', width: 130 },
        ],
    }
    useEffect(() => {
        if (!HotelIds.length) return;
        (async () => {
            try {
                setIsLoading(true);
                const [hotels, canceledReservations, createdReservations] = await Promise.all([
                    GetHotels({
                        IsActive: true
                    }),
                    GetReservations({
                        HotelIds,
                        FromCancelDate: moment().subtract(1, "day").toISOString(),
                        ToCancelDate: moment().toISOString(),
                        IncludeCanceled: true
                    }),
                    GetReservations({
                        HotelIds,
                        FromCreateDate: moment().subtract(1, "day").toISOString(),
                        ToCreateDate: moment().toISOString()
                    })
                ])

                const data = [...canceledReservations.map(res => { return { ...res, action: 'Canceled Reservations', HotelName: hotels.find(x => x.Id == res.HotelId)?.Name } }), ...createdReservations.map(res => { return { ...res, action: 'Created Reservations', HotelName: hotels.find(x => x.Id == res.HotelId)?.Name } })]
                let totals = []

                totals = _.flatMap(await Promise.all(_.map(_.groupBy(data, "HotelId"), (reservations, HotelId) => {
                    return GetReservationTotals({
                        ReservationIDs: reservations.map(res => res.Id),
                        HotelId: HotelId,
                        TargetCurrencyID: window.user?.CurrentHotel?.MainCurrencyId || 1
                    })
                })))
                if (totals) {
                    data.forEach(reservation => {
                        const total = totals.find(x => x.ReservationID === reservation.Id)
                        if (total) {
                            if (reservation.action === 'Canceled Reservations') {
                                total.TotalAmountDebitAfterTax *= -1
                                reservation.TotalAmountDebitAfterTax = total.TotalAmountDebitAfterTax
                            } else {
                                reservation.TotalAmountDebitAfterTax = total.TotalAmountDebitAfterTax
                            }
                        }
                    })
                }
                setData(data);
            } catch (error) {
                error.status === 400 ? onWarning(error) : onError(error);
                setIsLoading(false);
            } finally {
                setIsLoading(false);
            }
        })();

    }, [HotelIds]);


    return (
        <>
            {isLoading ? (
                <Dimmer active inverted>
                    <Loader inline='centered' size='medium' />
                </Dimmer>
            ) : (
                <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                    <div style={{ flex: 1, display: "flex", overflowX: "auto" }}>
                        <GridPanel options={gridOptions} data={data} />
                    </div>
                </div>
            )}
        </>
    );
};

lastReservationsWidget.propTypes = {
    HotelIds: PropTypes.array,
};